import React, {useRef} from "react";

import {Button} from 'semantic-ui-react'


const Importer = (props) => {
    const inputFile = useRef(null);
    let fileReader;
    let fileName = '';

    const onReadFile = () => {
        const content = fileReader.result;
        props.importTournament(fileName, content);
    }

    const readFile = (file) => {
        fileReader = new FileReader();
        fileReader.onloadend = onReadFile;
        fileReader.readAsText(file);
    }

    const handleFileUpload = e => {
        const { files } = e.target;
        if (files && files.length) {
            fileName = files[0].name;
            var parts = fileName.split(".");
            const fileType = parts[parts.length - 1];
            if(fileType !== 'json'){
                alert("Unsupported format.")
                return
            }
            readFile(files[0])
        }
      };


    const onImportClick = () => {
        inputFile.current.click();
    }

    return(
        <>
        <input
            style={{ display: "none" }}
            // accept=".zip,.rar"
            ref={inputFile}
            onChange={handleFileUpload}
            type="file"
        />
        <Button 
            label 
            icon='upload' 
            onClick={() => onImportClick()}
            content='Import' 
            basic className='melee'
        />
        </>
    )
}

export default Importer;